var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-info-banner",class:'is-' + _vm.tone,attrs:{"role":"status"}},[(_vm.icon)?_c('icon',{staticClass:"lp-info-banner__icon",attrs:{"name":_vm.icon}}):_vm._e(),_c('span',{staticClass:"lp-info-banner__text"},[_vm._t("default")],2),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }